import "./index.css";
const n = "_newLink_co5v7_1", o = "_linkIcon_co5v7_24", c = {
  newLink: n,
  linkIcon: o
};
export {
  c as s
};
//# sourceMappingURL=index.extra.js.map
